import ROUTE_PATH from "../constant/route";
import Home from "../pages/Home";
import VerifyOTP from "../pages/VerifyOTP";
import OtpSuccess from "../pages/OtpResponse/otpSuccess";
import OtpFailure from "../pages/OtpResponse/otpFailure";
import CustomerDetails from "../pages/CustomerDetails";
import PaymentSuccess from "../pages/PaymentResponse/paymentSuccess";
import PaymentFailure from "../pages/PaymentResponse/paymentFailure";
import Payment from "../pages/Payment";
import UnAuthentication from "../pages/UnAuthentication";
import { createBrowserRouter, Navigate } from "react-router-dom";
import HomeRoot from "../HomeRoot";

const prosureRoutes = () => {
  return {
    path: ROUTE_PATH.HOME,
    element: <HomeRoot />,
    children: [
      { path: ROUTE_PATH.HOME, element: <Home />}, // /prosure/customer-details
      { path: ROUTE_PATH.CUSTOMER_DETAILS, element: <CustomerDetails /> }, // /prosure/customer-details
      { path: ROUTE_PATH.VERIFY_OTP, element: <VerifyOTP /> }, // /prosure/verify-otp
      { path: ROUTE_PATH.SUCCESS_OTP, element: <OtpSuccess /> }, // /prosure/otp-success
      { path: ROUTE_PATH.FAILURE_OTP, element: <OtpFailure /> }, // /prosure/otp-failure
      { path: ROUTE_PATH.SUCCESS_PAYMENT, element: <PaymentSuccess /> }, // /prosure/payment-success
      { path: ROUTE_PATH.FAILURE_PAYMENT, element: <PaymentFailure /> }, // /prosure/payment-failure
      { path: ROUTE_PATH.PAYMENT, element: <Payment /> },
    ],
  };
};
const routesConfig = createBrowserRouter([
  prosureRoutes(),
  {
    path: "/", // Base path
    element: <Navigate to="/prosure" replace />, // Redirect root to /prosure
  },
  {
    path: ROUTE_PATH.UN_AUTH, // Standalone route for unauthorized access
    element: <UnAuthentication />,
  },
  {
    path: ROUTE_PATH.PAGE404, // Catch-all route for undefined paths
    element: <Navigate to={ROUTE_PATH.UN_AUTH} />,
  },
]);

export default routesConfig;
